<template>
    <div class="book-detail">
        <div class="content-nav-wrapper">
            <div class="title-wrapper">
                <span class="title">{{ $t('comb.copyrightWorkManagement') }}</span>
                <span>作品详情</span>
            </div>
        </div>
        <el-row class="base-content">
            <img v-if="book.coverImg" :src="`${UPLOAD_IMG_HOST}${book.coverImg}`" class="cover-img">
            <div class="content">
                <el-row>
                    <span class="title">{{ book.title }}</span>
                </el-row>
                <el-row>
                    <span class="inner-label">{{ $t('comb.workType') }}</span><span> {{ book.categoryLabel }}</span>
                </el-row>
                <el-row>
                    <span class="inner-label">I S B N</span><span> {{ book.isbn }}</span>
                </el-row>
                <el-row>
                    <span class="inner-label">{{ $t('word.publisher') }}</span><span> {{ book.publishCompany }}</span>
                </el-row>
                <el-row>
                    <span class="inner-label" style="display: inline;">{{ $t('comb.workIntro') }}</span>
                    <el-tooltip :content="book.intro" placement="top" popper-class="desc-popper">
                        <span class="one-line-desc">
                            {{ book.intro }}
                        </span>
                    </el-tooltip>
                </el-row>
            </div>
        </el-row>
        <el-row>
            <span class="label">{{ $t('comb.workAttachment') }}</span>
            <div class="attachment-wrapper" v-for="attachment in book.attachmentList">
                <span class="attachment-name">{{ attachment.fileName }}</span>
                <a class="download" :href="`${UPLOAD_IMG_HOST}/${attachment.fileUrl}`" download="attachment">下载</a>
            </div>
        </el-row>
        <el-row>
            <span class="label">{{ $t('comb.copyrightInfo') }}</span>
            <p class="copyright-info" v-if="book.bookContract && book.bookContract.exclusive">有声化后独家授权喜马拉雅FM使用</p>
            <p class="copyright-info" v-else>有声化后授权喜马拉雅FM使用</p>
        </el-row>
        <el-row v-if="book.status===5">
            <span class="label">{{ $t('comb.AuditResult') }}</span>
            <p class="intro"><span>拒绝原因：{{ book.bookApply.auditRemark}}</span></p>
            <p class="intro"><span>审核时间：{{ getFormatTime(book.bookApply.lastUpdateTime)}}</span></p>
        </el-row>
    </div>
</template>
<script>
    import axios from 'axios';
    import moment from 'moment';
    import shave from 'shave';
    export default {
        components: {
            axios
        },
        data() {
            return {
                book: {
                    category: {},
                    bookContract: {},

                }
            }
        },
        beforeMount() {
          this.getBookDetail();
        },
        updated() {
          this.shave();
        },
        methods: {
            getBookDetail() {
                const that = this;
                axios.get(`/api/book/detail/${that.$route.params.id}`).then(res => {
                    that.book = res.data.data;
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                });
            },
            getFormatTime(time) {
              return moment(time).format('YYYY-MM-DD HH:mm:ss')
            },
            shave() {
                shave('.one-line-desc', 20);
            }
        },
        computed: {
            UPLOAD_IMG_HOST() {
                return this.$store.state.UPLOAD_IMG_HOST;
            },
        }
    }

</script>
<style lang="sass">
    @import "../../../sass/copyright/bookDetail.scss";
</style>



// WEBPACK FOOTER //
// BookDetail.vue?2d70563b